import React from 'react';
import { useTranslation } from 'react-i18next';
import { HtmlContent } from '../../common/HtmlContent';

import './PowerupCard.css';
import { currencyFormatOnText } from '../../../services/utils';

const PowerupCard = ({
  detail = '',
  disabled = false,
  handleLearnMoreClick = () => { },
  included = false,
  title = '',
}) => {
  const { t } = useTranslation('changeCoverage');

  const formattedDetail = currencyFormatOnText(detail);

  return (
    <div className="Change-coverage-powerup-card">
      <div className="Change-coverage-powerup-card-top-row">
        <h4>{title}</h4>

        <div
          className="Change-coverage-powerup-card-status-pill"
          data-included={included}
        >
          <span />

          <span>{t(`preview.${included ? 'included' : 'notIncluded'}`)}</span>
        </div>
      </div>

      <HtmlContent
        classNameContainer="Change-coverage-powerup-card-detail"
        content={formattedDetail}
        elementType="p"
      />

      {disabled
        ? null
        : (
          <button
            className="Change-coverage-powerup-card-learn-more"
            onClick={handleLearnMoreClick}
            type="button"
          >
            <span>{t('preview.learnMore')}</span>
          </button>
        )}
    </div>
  );
};

export { PowerupCard };
